export const DURATION_FORMAT = 'short';
export const DURATION_OPTIONS = { largest: 2 };
